<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-03-30 17:37:44
-->
<template>
  <div class="footer-box">
    <div class="footer">
      <div class="totle">
        <span class="tol">总计：</span>
        <span class="price">￥{{payInfo.value}}</span>
        <a-button type="primary" class="accept-btn" @click="handleToPay()">提交订单</a-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Footer',
  data() {
    return {

    };
  },
  props: ['payInfo'],
  components: {
  },
  methods: {
    handleToPay() {
      this.$emit('handleToPay');
    },
  },
});
</script>
<style lang="stylus" scoped>
  .footer-box
    height 64px
    width 100%
    background #fff
    position fixed
    left 0
    bottom 0
    .footer
      width 1200px
      margin 0 auto
    .totle
      float right
      .tol
        color #333
        font-size 14px
      .price
        color #FF0018
        font-size 20px
        margin-right 23px
      .accept-btn
        width 115px
        height 50px
        font-size 16px
        margin-top 7px
        border-radius 5px
        background #3281dd
        color #fff
        border none
</style>
